import { render, staticRenderFns } from "./TrabajoAdicionalTable.vue?vue&type=template&id=3bc2048b"
import script from "./TrabajoAdicionalTable.vue?vue&type=script&lang=js"
export * from "./TrabajoAdicionalTable.vue?vue&type=script&lang=js"
import style0 from "./TrabajoAdicionalTable.vue?vue&type=style&index=0&id=3bc2048b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports